import React from 'react';

import { FeaturedPartner } from '@utils/backend-api/partners';

import FeaturedPartnerCard from './FeaturedPartnerCard';
import styles from './styles.module.scss';

const FeaturedPartnerContainer = ({
  featuredPartners,
}: {
  featuredPartners: FeaturedPartner[];
}) => {
  return (
    <>
      <div className={styles.partnersTitle}>
        <h3 className={styles.title}>Featured Partner{featuredPartners.length > 1 && 's'}</h3>
        <div className={styles.titleDesign}></div>
      </div>
      <div className={styles.partnersContainer}>
        {featuredPartners.map((partner) => (
          <FeaturedPartnerCard key={`partner-card-${partner.id}`} partner={partner} />
        ))}
      </div>
    </>
  );
};

export default FeaturedPartnerContainer;
